import { Directive, ElementRef, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { ElementDimensions } from '@model/element-resizing.model';
import { OnResizeService } from '@services/on-resize.service';

@Directive({
  selector: '[onResize]'
})
export class OnResizeDirective implements OnInit, OnDestroy {

  @Input() delayTime = 0;

  @Output('onResize') resizeEvent = new EventEmitter<ElementDimensions>();

  constructor(private _elementRef: ElementRef, private _onResizeService: OnResizeService) { }

  ngOnInit() {
    if (!this._elementRef.nativeElement) {
      return;
    }
    this._onResizeService.subscribeElement(this._elementRef.nativeElement, this.delayTime)
      .subscribe(item => {
        this.resizeEvent.emit(item);
      });
  }

  ngOnDestroy() {
    this._onResizeService.unsubscribeElement(this._elementRef.nativeElement);
  }
}
